import { render, staticRenderFns } from "./KYCRequestDetailModal.vue?vue&type=template&id=6c91f2fa&scoped=true"
import script from "./KYCRequestDetailModal.vue?vue&type=script&lang=js"
export * from "./KYCRequestDetailModal.vue?vue&type=script&lang=js"
import style0 from "./KYCRequestDetailModal.vue?vue&type=style&index=0&id=6c91f2fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c91f2fa",
  null
  
)

export default component.exports